export default __webpack_public_path__ + "824f8e8b8bc27b2e3426ed63f7ebeea5.png";